import { toast } from "react-toastify";
import i18n from "i18n";

const downloadFileFromBlob = (blob, fileName) => {
  const fileUrl = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = fileUrl;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const downloadExcelFile = (
  url: string,
  body: string,
  fileName: string,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  extraHeaders?: Record<string, string>
) => {
  setIsLoading(true);
  fetch(url, {
    method: "POST",
    body,
    headers: {
      "Content-Type": "application/json",
      ...extraHeaders,
    },
    // Auth is the HttpOnly "token" cookie (SameSite=None; Secure). Like
    // fetchBaseQuery, this raw fetch must opt in to send it cross-origin —
    // without it the cookie is dropped and the API returns 401.
    credentials: "include",
  })
    .then((response) => {
      setIsLoading(false);
      if (!response.ok) {
        toast.error(i18n.t("downloadFaild"));
        throw new Error("ההורדה נכשלה");
      }

      return response.blob();
    })
    .then((blob) => {
      downloadFileFromBlob(blob, fileName);
    })
    .catch((error) => {
      setIsLoading(false);
      console.error(error);
    });
};

export const downloadZipFolder = async (
  url: string,
  fileName: string,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  onReportRefetch: () => void
) => {
  setIsLoading(true);
  // Same cookie-auth requirement as downloadExcelFile (cross-origin → 401 without it).
  fetch(url, { credentials: "include" })
    .then((response) => {
      if (!response.ok) {
        toast.error(i18n.t("downloadFaild"));
        throw new Error("ההורדה נכשלה");
      }

      return response.blob();
    })
    .then((blob) => {
      downloadFileFromBlob(blob, fileName);
      setIsLoading(false);
    })
    .then(() => onReportRefetch())
    .catch((error) => {
      console.error("Error:", error);
      setIsLoading(false);
    });
};
